/** 支払いタイプ：提案時に1% */
export const RFP_PAYMENT_OPTION_ONE_PERCENT = {
    feeBase: '提案金額',
    feeRate: 0.01,
    label: '提案時に1％',
    longLabel: 'ご提案時に予算上限金額の1％',
    status: '提案',
    timing: '提案された',
    value: 3,
};
/** 支払いタイプ：面談確定時に3% */
export const RFP_PAYMENT_OPTION_THREE_PERCENT = {
    feeBase: '提案金額',
    feeRate: 0.03,
    label: '面談確定時に3％',
    longLabel: 'ご面談時に予算上限金額の3％',
    status: '提案',
    timing: '面談確定された',
    value: 4,
};
/** 支払いタイプ：受注時に10% */
export const RFP_PAYMENT_OPTION_TEN_PERCENT = {
    feeBase: '受注金額',
    feeRate: 0.1,
    label: '受注時に10%',
    longLabel: '受注時に発注金額の10％',
    status: '受注',
    timing: 'PJを受注された',
    value: 5,
};
/** 支払タイプ:提案時に2% */
export const RFP_PAYMENT_OPTION_TWO_PERCENT = {
    feeBase: '案件の予算上限金額',
    feeRate: 0.02,
    label: '提案時に2％',
    longLabel: 'ご提案時に予算上限金額の2％',
    status: '提案',
    timing: '提案された',
    value: 6,
};
/** 支払いタイプ一覧 */
export const RFP_PAYMENT_OPTIONS = [
    RFP_PAYMENT_OPTION_ONE_PERCENT,
    RFP_PAYMENT_OPTION_THREE_PERCENT,
    RFP_PAYMENT_OPTION_TEN_PERCENT,
    RFP_PAYMENT_OPTION_TWO_PERCENT,
];
